"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  var _theme$useToken = _antd.theme.useToken(),
    token = _theme$useToken.token;
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_antd.Badge, {
    count: 5
  }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    shape: "square",
    size: "large"
  })), /*#__PURE__*/_react.default.createElement(_antd.Badge, {
    count: 0,
    showZero: true
  }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    shape: "square",
    size: "large"
  })), /*#__PURE__*/_react.default.createElement(_antd.Badge, {
    count: /*#__PURE__*/_react.default.createElement(_icons.ClockCircleFilled, {
      style: {
        color: token.colorError
      }
    })
  }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    shape: "square",
    size: "large"
  })));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorError', 'colorBorderBg', 'colorBgContainer'],
  key: 'badge'
};
var _default = exports.default = componentDemo;